import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { filter, Subscription } from 'rxjs';
import { dropDown } from '../../animations/drop-down.animation';
import { slideInOut } from '../../animations/slide-in-out.animation';
import { ASelectMultipleComponent } from '../a-select-multiple/a-select-multiple.component';
import { ApiService, RequirementLevel } from 'src/app/core/services/api.service';
import { SENIORITY_LIST } from 'src/app/core/const.variables';
import { opacityInOut } from '../../animations/opacity-in-out.animation';

@Component({
  selector: 'hard-skills-tree',
  templateUrl: 'hard-skills-tree.component.html',
  styleUrls: ['./hard-skills-tree.component.scss'],
  animations: [ slideInOut, dropDown, opacityInOut ]
})
export class HardSkillsTreeComponent implements OnInit, OnDestroy {

  @ViewChild(ASelectMultipleComponent) techSearch: ASelectMultipleComponent;
  @Input() skillsList$ = null;
  @Input() jobTitle = '';
  @Input() mustHave = false;
  @Input() suppressSeniorityWarning = false;
  @Input() showSetSeniority = false;
  @Input() set seniority(val) {
    if (val) {
      console.log('Seniority input changed to:', val);
      this.senioritySelected = val;
      this.seniorityControl.setValue(val); //  'junior' | 'middle' | 'senior'
    }
  };
  @Input() set presetLoading(val) {
    this.presetIsLoading = val;
  };
  @Output() setSkills = new EventEmitter<any>();
  @Output() setSeniority = new EventEmitter<any>();
  @Output() setTab = new EventEmitter<string>();
  loading = false;
  subLoading = false;
  mainLoading = true;
  showSkillsMenu = false;
  totalPages = 0;
  activePages = 1;
  tradeOffMax = 100;
  tradeOffSelected = 0;
  singleTradeOffMax = null;
  singleTradeOffSelected = null;
  singleSelectedBranch = null;
  techForm = new FormArray([]);
  searchGlobalForm = new FormControl('');
  searchForm = new FormControl('');
  searchTerm = '';
  noSkillsFound = false;
  activeSkill: any = null;
  currentViewSkills: any = [];
  allSkills: any = [];
  mustHaveSkills: any = []; 
  niceHaveSkills: any = [];
  shouldHaveSkills: any = [];
  couldHaveSkills: any = [];
  lowPrioritySkills: any = [];
  activeBranches = [];
  searchSkillsList = null;
  singleSkillControl = null;
  // removeSkillNotify = false;
  currentTab: 'all' | 'preset' = 'preset';
  seniorityList = SENIORITY_LIST;
  seniorityControl = new FormControl('middle');
  senioritySelected = null;
  seniorityChangeNotify = { change: null, reset: null };
  skillSetWasChanged = false;
  presetIsLoading = false;
  deleteId = null; 
  private branchInsert = null;
  private skillsPerPage = 0;
  private skillsSub: Subscription;
  private searchSkillsSub: Subscription;
  private searchResultsSub: Subscription;

  constructor(private apiService: ApiService) {
  }

  ngOnInit(): void {
    this.setTab.emit('preset');
    this.skillsSub = this.skillsList$.pipe(filter(val => val !== null)).subscribe(skills => {
      if (!this.allSkills.length || this.allSkills.length !== skills.length) {
        this.totalPages = Math.ceil(skills.length / 9);
        const chunk = Math.floor(skills.length / this.totalPages) + 1;
        this.skillsPerPage = chunk > 9 ? 9 : chunk;
        setTimeout(() => this.mainLoading = false, 200);
      }

      this.allSkills = skills;
      this.setSelectedSkills(this.allSkills);
      this.currentViewSkills = this.totalPages > 1 ? this.chunkArray(skills, this.skillsPerPage)[this.activePages - 1] : skills;
      this.countHasValues(this.currentViewSkills);
    });

    this.searchSkillsSub = this.searchGlobalForm.valueChanges.subscribe(query => {
      if (this.searchResultsSub) {
        this.searchResultsSub.unsubscribe();
      }
      if (query) {
        this.searchResultsSub = this.apiService.searchHardSkills(query).subscribe(result => {
          if (result) {
            const selectedItems = [];
            this.searchResultsSub = null;
            this.allSkills.map(branch => branch.skills.map(skill => skill.experience && selectedItems.push(skill.id)));
            const withSelected = result.map(branch => ({
              ...branch,
              skills: branch.skills.map(skill => ({ ...skill, selected: selectedItems.includes(skill.id) }))
            }))
            this.searchSkillsList = withSelected;
          } else {
            this.searchSkillsList = [];
          }
        });
      } else {
        this.searchSkillsList = [];
        this.searchResultsSub = null;
      }
    })
  }

  showMenuSkills() {
    this.showSkillsMenu = true;
  }

  switchPage(to: number) {
    this.activePages = this.activePages + to;
    this.switchSlider();
  }

  selectMenuSkill(skill = null) {
    if (skill) { 
      this.selectSkill(skill);
      this.activePages = 1;
    }
    this.showSkillsMenu = false;
  }

  ngOnDestroy(): void {
    if (this.skillsSub) { this.skillsSub.unsubscribe(); }
    this.searchSkillsSub.unsubscribe();
  }

  selectSkill(skill: any) {
    if (skill) {
      this.skillSetWasChanged = true;
      this.activeSkill = skill;
      this.techForm = new FormArray([]);
      if (this.activeSkill.skills && this.activeSkill.skills.length) {
        this.activeSkill.skills.map((item: any) => {
          this.techForm.push(this.skillGroup(item));
        });
        this.tradeOffSelected = this.activeSkill.skills.filter(item => item.experience === 5).length;
        this.tradeOffMax = this.countTradeOff(this.activeSkill.skills.length);
        this.techForm.valueChanges.subscribe(vals => {
          this.tradeOffSelected = vals.filter(item => item.experience === 5).length;
        });
        this.searchForm.valueChanges.subscribe(term => {
          this.searchTerm = term && term.length > 1 ? term.toLowerCase() : '';
          this.noSkillsFound = this.noSkillsFoundCheck();
        });
      }
    } else {
      // this.skillsToStore();
      this.activeSkill = null;
      this.noSkillsFound = false;
      this.tradeOffSelected = 0;
      this.techForm = new FormArray([]);
      this.searchForm = new FormControl('');
      this.searchTerm = '';
      setTimeout(() => document.getElementById('hard-skills-tree').scrollIntoView({ behavior: 'smooth', block: 'center' }), 500);
    }
  }

  private skillGroup(item) {
    return new FormGroup({
      id: new FormControl(item.id),
      name: new FormControl(item.name),
      experience: new FormControl(item.experience),
      years: new FormControl(item.years),
      isRequired: new FormControl(this.mustHave && item.isRequired ? true : false),
      isValidationRequired:new FormControl(item.isValidationRequired),
      requirementLevel: new FormControl(item.requirementLevel !== undefined ? item.requirementLevel : 4),
    });
  }

  selectedCount(id) {
    return this.activeBranches.find(item => item.id === id).count;
  }

  skillChanged(val) {
    const skillBranch = this.allSkills.find(branch => branch.id === val.branch.id);
    if (skillBranch) {
      this.singleSelectedBranch = skillBranch;
      this.singleTradeOffMax = this.countTradeOff(val.selected ? skillBranch.skills.length : skillBranch.skills.length + 1);
      this.singleTradeOffSelected = skillBranch.skills.filter(val => val.experience === 5).length;

      let skillExists = null;
      this.allSkills.map(branch => (branch.skills.map(skill => {
        if (skill.id === val.skill.id) {
          skillExists = skill;
        }
      })))
      
      // Get default experience value based on seniority level
      const defaultExperience = this.getDefaultExperienceForSeniority();
      const defaultYears = defaultExperience > 0 ? Math.round(defaultExperience / 2) : 0;
      
      console.log('Current seniority level:', this.senioritySelected, 'Setting default experience:', defaultExperience);

      if (!skillExists) {
        this.branchInsert = { branch: val.branch, insert: false };
        this.singleSkillControl = this.skillGroup({ 
          ...val.skill, 
          experience: defaultExperience, 
          years: defaultYears, 
          isRequired: false ,
          isValidationRequired : false,
          requirementLevel: 4
        });
      } else {
        this.singleSkillControl = this.skillGroup({ ...skillExists });
      }
    } else {
      this.branchInsert = { branch: val.branch, insert: true };
      this.singleTradeOffMax = 1;
      this.singleTradeOffSelected = 0;
      
      // Get default experience value based on seniority level
      const defaultExperience = this.getDefaultExperienceForSeniority();
      const defaultYears = defaultExperience > 0 ? Math.round(defaultExperience / 2) : 0;
      
      this.singleSkillControl = this.skillGroup({ 
        ...val.skill, 
        experience: defaultExperience, 
        years: defaultYears, 
        isRequired: false ,
        isValidationRequired : false,
        requirementLevel: 4
      });
    }
  }

  // removeSkillResult(result) {
  //   if (result) {
  //     this.addRemoveSkill(result, false);
  //   } 
  //   this.removeSkillNotify = null;
  // }

  closeSingleSkill(save = true) {
    if (save) {
      this.skillSetWasChanged = true;
      const skill = this.singleSkillControl.value;
      if (this.branchInsert) {
        const updatedItems = this.branchInsert.insert 
          ? [ ...this.allSkills, { ...this.branchInsert.branch, skills: [skill] }]
          : this.allSkills.map(b => b.id === this.branchInsert.branch.id ? { ...b, skills: [ skill, ...b.skills]} : b)
        this.setSkills.emit(updatedItems);
        if (this.singleSelectedBranch) {
          const branch = updatedItems.find(branch => branch.id === this.singleSelectedBranch.id);
          this.selectSkill(branch);
        }
      } else {
        this.addRemoveSkill(skill, true);
      }
    }
    this.branchInsert = null;
    this.singleSkillControl = null;
    this.singleTradeOffMax = 1;
    this.singleTradeOffSelected = 0;
    this.singleSelectedBranch = null;
  }

  selectTab(param) {
    this.currentTab = param;
    this.setTab.emit(param)
    if (this.currentTab === 'all') {
      this.selectSkill(null);
    }
  }

  addRemoveSkill(val, add = false, timeout = 0) {
    this.deleteId = val.id;
    this.skillSetWasChanged = true;
    const updatedItems = this.allSkills.map(branch => ({ 
      ...branch,
      skills: branch.skills.map(skill => ({
        ...skill,
        experience: skill.id === val.id ? add ? val.experience : 0 : skill.experience,
        years: skill.id === val.id ? add ? val.years : 0 : skill.years,
        isRequired: skill.id === val.id ? add ? val.isRequired : false : skill.isRequired ? skill.isRequired : false,
        isValidationRequired: skill.id === val.id ? (add ? !!val.isValidationRequired : false) : (skill.isValidationRequired ?? false),
        requirementLevel: skill.id === val.id ? add ? val.requirementLevel : 0 : skill.requirementLevel !== undefined ? skill.requirementLevel : 0
      }))
    }));
    setTimeout(() => {
      this.deleteId = null;
      this.setSkills.emit(updatedItems);
      if (this.singleSelectedBranch) {
        const branch = updatedItems.find(branch => branch.id === this.singleSelectedBranch.id);
        this.selectSkill(branch);
      }
    }, timeout);
  }

  private countHasValues(skills) {
    this.activeBranches = skills.map(branch => ({ id: branch.id, count: branch.skills.filter(item => item.experience).length }));
  }

  skillsToStore() {
    const skills = this.techForm.getRawValue();
    if (skills && skills.length) {
      const activeSkill = { ...this.activeSkill, skills };
      const updatedItems = this.allSkills.map((el: any) => el.id === activeSkill.id ? activeSkill : el);
      this.setSkills.emit(updatedItems);
    }
  }

  seniorityChange(param = null) {
    const level = param && param.value ? param.value : null;
    
    if (level !== this.senioritySelected) {
      // If suppressSeniorityWarning is true, skip showing the warning dialog
      if (this.suppressSeniorityWarning) {
        this.senioritySelected = level;
        this.setSeniority.emit(level);
      } else {
        // Show warning dialog as usual
        this.seniorityChangeNotify = level ? { change: level, reset: null } : { change: null, reset: true };
      }
    }
  }

  seniorityChangeConfirm(result, level) {
    if (result) {
      this.skillSetWasChanged = false;
      this.senioritySelected = level;
      this.setSeniority.emit(level);
    } else if (level) {
      this.seniorityControl.setValue(this.senioritySelected);
      this.seniorityChangeNotify = null;
    }
    setTimeout(() => this.seniorityChangeNotify = { change: null, reset: null });
  }

  private switchSlider() {
    this.toggleClass();
    setTimeout(() => {
      this.currentViewSkills = this.chunkArray(this.allSkills, this.skillsPerPage)[this.activePages - 1];
      this.countHasValues(this.currentViewSkills);
      setTimeout(() => this.toggleClass(), 100);
    }, 400)
  }

  private toggleClass() {
    // this.loading = !this.loading;
    // setTimeout(() => this.subLoading = !this.subLoading, 200);
    if (this.loading) {
      this.loading = !this.loading;
      setTimeout(() => this.subLoading = !this.subLoading, 200);
    } else {
      setTimeout(() => this.loading = !this.loading, 100);
      this.subLoading = !this.subLoading;
    }
  }

  private chunkArray(arr: any, size: number = 8) {
    const myArray = [];
    for (let i = 0; i < arr.length; i += size) {
      myArray.push(arr.slice(i, i + size));
    }
    return myArray;
  }

  private countTradeOff(length) {
    return length <= 3 ? length : Math.round(length > 6 ? (length * 0.7) : (length * 0.8));
  }

  private noSkillsFoundCheck() {
    if (this.searchTerm && this.searchTerm.length > 1) {
      const skills = this.techForm.getRawValue().filter(item => item.name.toLowerCase().includes(this.searchTerm));
      return skills.length === 0;
    }
    return false;
  }
  
  /**
   * Returns the default experience value based on the current seniority level
   * junior: 1, middle: 3, senior: 5
   */
  private getDefaultExperienceForSeniority(): number {
    // Default to middle (3) if no seniority is selected
    if (!this.senioritySelected) {
      return 3;
    }
    
    switch (this.senioritySelected) {
      case 'junior':
        return 1;
      case 'middle':
        return 3;
      case 'senior':
        return 5;
      default:
        return 3; // Default to middle level if unknown
    }
  }

  private setSelectedSkills(allSkills) {
    let mustHaveSkills = [];
    let niceHaveSkills = [];
    let shouldHaveSkills = [];
    let couldHaveSkills = [];
    let lowPrioritySkills = [];
    const formatVals = (branch, skills) => skills.map(val => ({
      selected: true,
      branch: { name: branch.name, id: branch.id },
      skill: { ...val, selected: true }
    }));
    allSkills.map(branch => {
      mustHaveSkills = [ 
        ...mustHaveSkills,
        ...formatVals(branch, branch.skills.filter(item => this.mustHave ? item.isRequired ? item.isRequired && item.experience : item.requirementLevel === RequirementLevel.MustHave : item.experience))
      ];
      if (this.mustHave) {
        niceHaveSkills = [
          ...niceHaveSkills,
          ...formatVals(branch, branch.skills.filter(item => (item.isRequired ? !item.isRequired : item.requirementLevel === RequirementLevel.NiceToHave) && item.experience))
        ];
        shouldHaveSkills = [
        ...shouldHaveSkills,
        ...formatVals(branch, branch.skills.filter(item => item.requirementLevel === RequirementLevel.ShouldHave && item.experience))
      ];
      couldHaveSkills = [
        ...couldHaveSkills,
        ...formatVals(branch, branch.skills.filter(item => item.requirementLevel === RequirementLevel.CouldHave && item.experience))
      ];
      lowPrioritySkills = [
        ...lowPrioritySkills,
        ...formatVals(branch, branch.skills.filter(item => item.requirementLevel === RequirementLevel.LowPriority && item.isRequired == false && item.experience))
      ];  
      }
    });
    this.mustHaveSkills = mustHaveSkills;
    this.niceHaveSkills = niceHaveSkills;
    this.shouldHaveSkills = shouldHaveSkills;
    this.couldHaveSkills = couldHaveSkills;
    this.lowPrioritySkills = lowPrioritySkills;
  }

}
